// Hardcoded list of users whose Polymarket Gnosis Safe was deployed after the
// V2 cutover (2026-05-04 12:30 UTC) and is therefore rejected by Polymarket.
// They are force-routed onto the deposit-wallet path; their stuck balances are
// drained by the UpgradeBrokenSafeModal. Importable from both client and
// server runtimes (no 'server-only').
//
// History: see docs/superpowers/specs/2026-05-10-broken-safe-upgrade-modal-design.md

export interface LegacyBrokenSafeEntry {
	safeAddress: `0x${string}`
	email: string
}

export const LEGACY_BROKEN_SAFES = {
	'a3fb0651-702c-429b-aa64-1bf11cd6b793': {
		safeAddress: '0x24aC7bfa5A5b75D70661763B9cC9f603914268Ce',
		email: 'amadosx@proton.me',
	},
	'5f0858d3-b668-4073-bea1-e871e1a01b5a': {
		safeAddress: '0x39b7Dc2b6c0A3b037Bb833dD938479e85fEC557a',
		email: 'wilvmp20@gmail.com',
	},
	'fd024089-fa2a-49ca-8e19-9c4c3e6969a3': {
		safeAddress: '0x471535968c4BBEDd1870150CbF9DE1b79ed3ff5b',
		email: '0xe98b243b@wallet.local',
	},
	'5ce8aa7d-f1c0-4eb8-bcc9-6405a63aacfd': {
		safeAddress: '0x4a27b0D783A9fE5b3F9eE69176d3AE6fC0F53c30',
		email: 'zhangqing001105@gmail.com',
	},
	'b709f90e-6caf-4764-bb5f-77aa16436ba0': {
		safeAddress: '0x669ADC11Dd7eB7eb0161347467f6fF813d399Aa8',
		email: '0x0d5f977d@wallet.local',
	},
	'40d4a15b-1f27-431f-b9af-bd5b07fc3f14': {
		safeAddress: '0xD6f33ADEfE9df93931C1A4C5258D1039F00bD58e',
		email: '0x8f6c5b26@wallet.local',
	},
	'10d9558e-4896-473a-9b8c-1d92ec986f10': {
		safeAddress: '0xeb3D64D2798B95886282BcBFf06e7DFBD3114823',
		email: 'uyiaessien@gmail.com',
	},
	'741f82d0-3912-4292-91f9-8e582b142b49': {
		safeAddress: '0xF6D8beb6A65bd79f29D7A7E8d5240dfc5A5F2BE3',
		email: 'samridhsingh092001.ul@gmail.com',
	},
	'8f01683d-2953-4a27-ab7f-2ed39d3186a3': {
		safeAddress: '0x050f289F5FbB9240d721BA79adE5F781f4d27f0b',
		email: 'hmj1385@gmail.com',
	},
	'd3c7adaf-784c-4f05-b42c-360162bbfd0a': {
		safeAddress: '0xb6019A1f5Fa7591d2af58728DF37A4eb07b1247d',
		email: '0xfdda4509@wallet.local',
	},
	'a4c55eaf-907e-4688-b6cc-b7c3b16339ec': {
		safeAddress: '0x45f4F39296f5A451048b0B801aD32042A35004a4',
		email: 'sentenceswild@gmail.com',
	},
} as const satisfies Record<string, LegacyBrokenSafeEntry>

export function isLegacyBrokenSafeUser(userId: string | undefined | null): boolean {
	return !!userId && Object.hasOwn(LEGACY_BROKEN_SAFES, userId)
}

export function getLegacyBrokenSafe(
	userId: string | undefined | null
): LegacyBrokenSafeEntry | null {
	if (!(userId && Object.hasOwn(LEGACY_BROKEN_SAFES, userId))) return null
	return LEGACY_BROKEN_SAFES[userId as keyof typeof LEGACY_BROKEN_SAFES]
}
